export default __webpack_public_path__ + "static/media/corporate.e3cbe1cc.jpg";